import { useMemo } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { useOrganizationsInfiniteQuery } from 'features/organizations/queries';

export const useOrganizationRequestContent = ({ organizationId }: { organizationId: string }) => {
  const { data: organizations, isLoading: isLoadingOrganizations } = useOrganizationsInfiniteQuery({
    filter: { order: 'channels', scope: 'joined' },
  });
  const allOrganizations = organizations?.pages.flatMap((organizationsPaginated) => organizationsPaginated.data);

  const selectedOrganization = allOrganizations?.find(
    (channelOrganization) => channelOrganization.id === organizationId,
  );
  const isDefaultOrganization = selectedOrganization?.isDefault;

  return useMemo(
    () => ({
      allOrganizations,
      isLoadingOrganizations,
      requestOrganizationId: isDefaultOrganization ? undefined : organizationId,
    }),
    [allOrganizations, isDefaultOrganization, isLoadingOrganizations, organizationId],
  );
};
